export const SESSIONS_CHANGE_FIELD = 'SESSIONS_CHANGE_FIELD',
      SESSIONS_CHANGE_CUSTOM_DATE_RANGE = 'SESSIONS_CHANGE_CUSTOM_DATE_RANGE',
      SESSIONS_MOVE_CUSTOM_DATE_RANGE = 'SESSIONS_MOVE_CUSTOM_DATE_RANGE',
      //
      HANDOFF_CHANGE_FIELD = 'HANDOFF_CHANGE_FIELD',
      HANDOFF_CHANGE_CUSTOM_DATE_RANGE = 'HANDOFF_CHANGE_CUSTOM_DATE_RANGE',
      HANDOFF_MOVE_CUSTOM_DATE_RANGE = 'HANDOFF_MOVE_CUSTOM_DATE_RANGE',
      //
      TAG_CHANGE_FIELD = 'TAG_CHANGE_FIELD',
      TAG_CHANGE_CUSTOM_DATE_RANGE = 'TAG_CHANGE_CUSTOM_DATE_RANGE',
      TAG_MOVE_CUSTOM_DATE_RANGE = 'TAG_MOVE_CUSTOM_DATE_RANGE',
      //
      USERS_CHANGE_FIELD = 'USERS_CHANGE_FIELD',
      USERS_CHANGE_CUSTOM_DATE_RANGE = 'USERS_CHANGE_CUSTOM_DATE_RANGE',
      USERS_MOVE_CUSTOM_DATE_RANGE = 'USERS_MOVE_CUSTOM_DATE_RANGE',
      //
      INTERACTIONS_CHANGE_FIELD = 'INTERACTIONS_CHANGE_FIELD',
      INTERACTIONS_CHANGE_CUSTOM_DATE_RANGE = 'INTERACTIONS_CHANGE_CUSTOM_DATE_RANGE',
      INTERACTIONS_MOVE_CUSTOM_DATE_RANGE = 'INTERACTIONS_MOVE_CUSTOM_DATE_RANGE',
      //
      MESSAGES_CHANGE_FIELD = 'MESSAGES_CHANGE_FIELD',
      MESSAGES_CHANGE_CUSTOM_DATE_RANGE = 'MESSAGES_CHANGE_CUSTOM_DATE_RANGE',
      MESSAGES_MOVE_CUSTOM_DATE_RANGE = 'MESSAGES_MOVE_CUSTOM_DATE_RANGE',
      //
      SENTIMENTS_CHANGE_FIELD = 'SENTIMENTS_CHANGE_FIELD',
      SENTIMENTS_CHANGE_CUSTOM_DATE_RANGE = 'SENTIMENTS_CHANGE_CUSTOM_DATE_RANGE',
      SENTIMENTS_MOVE_CUSTOM_DATE_RANGE = 'SENTIMENTS_MOVE_CUSTOM_DATE_RANGE',
      //
      OVERVIEW_CHANGE_FIELD = 'OVERVIEW_CHANGE_FIELD',
      OVERVIEW_CHANGE_CUSTOM_DATE_RANGE = 'OVERVIEW_CHANGE_CUSTOM_DATE_RANGE',
      OVERVIEW_MOVE_CUSTOM_DATE_RANGE = 'OVERVIEW_MOVE_CUSTOM_DATE_RANGE',
      //
      EXPORT_ANALYTICS_V2_REQUEST = 'EXPORT_ANALYTICS_V2_REQUEST',
      LOAD_EXPORTS_REQUEST = 'LOAD_EXPORTS_REQUEST',
      DELETE_EXPORT_ITEM_REQUEST = 'DELETE_EXPORT_ITEM_REQUEST',
      RESET_EXPORTS_REQUEST = 'RESET_EXPORTS_REQUEST',
      SAVE_REPORTING_CONFIG_REQUEST = 'SAVE_REPORTING_CONFIG_REQUEST',
      FETCH_REPORTING_CONFIG_REQUEST = 'FETCH_REPORTING_CONFIG_REQUEST',
      UPDATE_REPORTING_CONFIG = 'UPDATE_REPORTING_CONFIG',
      //
      UPDATE_EXPORT_API_CONFIG = 'UPDATE_EXPORT_API_CONFIG',
      UPDATE_EXPORT_API_AZURE_CONFIG = 'UPDATE_EXPORT_API_AZURE_CONFIG',
      UPDATE_EXPORT_API_AMAZONS3_CONFIG = 'UPDATE_EXPORT_API_AMAZONS3_CONFIG',
      UPDATE_EXPORT_API_GOOGLE_CONFIG = 'UPDATE_EXPORT_API_GOOGLE_CONFIG',
      UPDATE_EXPORT_API_OBS_CONFIG = 'UPDATE_EXPORT_API_OBS_CONFIG',
      FETCH_EXPORT_API_CONFIG_REQUEST = 'FETCH_EXPORT_API_CONFIG_REQUEST',
      SAVE_EXPORT_API_CONFIG_REQUEST = 'SAVE_EXPORT_API_CONFIG_REQUEST',
      //
      OPENING_EVENTS_CHANGE_FIELD = 'OPENING_EVENTS_CHANGE_FIELD',
      OPENING_EVENTS_CHANGE_CUSTOM_DATE_RANGE = 'OPENING_EVENTS_CHANGE_CUSTOM_DATE_RANGE',
      OPENING_EVENTS_MOVE_CUSTOM_DATE_RANGE = 'OPENING_EVENTS_MOVE_CUSTOM_DATE_RANGE',
      //
      RESOLVED_BY_BOT_CHANGE_FIELD = 'RESOLVED_BY_BOT_CHANGE_FIELD',
      RESOLVED_BY_BOT_CHANGE_CUSTOM_DATE_RANGE = 'RESOLVED_BY_BOT_CHANGE_CUSTOM_DATE_RANGE',
      RESOLVED_BY_BOT_MOVE_CUSTOM_DATE_RANGE = 'RESOLVED_BY_BOT_MOVE_CUSTOM_DATE_RANGE',
      //
      CLOSE_EXPORT_ERROR_MODAL = 'CLOSE_EXPORT_ERROR_MODAL'